import { render, staticRenderFns } from "./BlockFormError.vue?vue&type=template&id=1d01c5e0&scoped=true&"
import script from "./BlockFormError.vue?vue&type=script&lang=ts&"
export * from "./BlockFormError.vue?vue&type=script&lang=ts&"
import style0 from "./BlockFormError.vue?vue&type=style&index=0&id=1d01c5e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d01c5e0",
  null
  
)

export default component.exports